import React, { useEffect, useState } from 'react';
import { Navbar, Nav, NavItem, Button, Image } from 'react-bootstrap';
import { useCollectionDataOnce } from 'react-firebase-hooks/firestore';
import firebase from 'firebase';
import 'firebase/firestore';

import useAuth from '../utils/firebase';
import Editor from '../components/editor';
import Headline from '../components/headline';
import Article from '../components/article';

const logo = require('../assets/icon.png');

function Home(props) {
    const { user, signout } = useAuth();
    const [editorState, setEditor] = useState(false);
    const [headlineState, setHeadline] = useState(false);

    const closeEditor = () => setEditor(false);
    const openEditor = () => setEditor(true);

    const openHeadline = () => setHeadline(true);
    const closeHeadline = () => setHeadline(false);

    const [articleList, loading, error] = useCollectionDataOnce(
        firebase.firestore().collection('articles').orderBy('created', 'desc'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );

    useEffect((props) => {
        if (!user) {
            props.history.push('/login');
        }
    }, [user])

    const SignOut = () => {
        signout();
    }

    return (
        <div className="App">
            <Navbar bg='light' expand="lg">
                <Navbar.Brand>
                    <Image src={logo} width={50} />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto">
                        <NavItem>
                            <Button className="nav-link" variant="inherit" onClick={openEditor}>Nouvel article</Button>
                        </NavItem>
                        <NavItem>
                            <Button className="nav-link" variant="inherit" onClick={openHeadline}>Headline News</Button>
                        </NavItem>
                        <NavItem>
                            <Button onClick={SignOut} className="nav-link" variant="inherit" >Déconnexion</Button>
                        </NavItem>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>

            {editorState && <Editor show={editorState} close={closeEditor} />}
            {headlineState && <Headline show={headlineState} close={closeHeadline} />}

            <div className="articles-list">
                {error && <strong>Error: {JSON.stringify(error)}</strong>}
                {loading && <span>Collection: Loading...</span>}
                {articleList && (
                    <span>
                        {
                            articleList.map(article => (
                                <div key={article.id}>
                                    <Article doc={article} />
                                </div>
                            ))
                        }
                    </span>
                )}
            </div>
        </div >
    )
}

export default Home